
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/aiAssistantPanel/assistant/widgets/widgets/FallbackWidget/FallbackWidget.module.scss.css.virtualfile';
        module.exports = {"text":"_text_1r3cf_1"};